import { render, staticRenderFns } from "./ProjectSimple.vue?vue&type=template&id=0d000459&"
import script from "./ProjectSimple.vue?vue&type=script&lang=js&"
export * from "./ProjectSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports